import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
} from '@/api/offlineanalysisserv'

export default {
  state: {
    state_OfflineAnalysis_GetAllResult: null,
    state_OfflineAnalysis_SearchByNameResult: null,
    state_OfflineAnalysis_GetPageResult: null,
    state_OfflineAnalysis_GetDetailResult: null,
    state_OfflineAnalysis_ModifyObjResult: null,
    state_OfflineAnalysis_DeleteObjResult: null,
  },
  mutations: {
    SET_OFFLINEANALYSIS_GETALL_RESULT: (state, rst) => {
      state.state_OfflineAnalysis_GetAllResult = rst;
    },
    SET_OFFLINEANALYSIS_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_OfflineAnalysis_SearchByNameResult = rst;
    },
    SET_OFFLINEANALYSIS_GETPAGE_RESULT: (state, rst) => {
      state.state_OfflineAnalysis_GetPageResult = rst;
    },
    SET_OFFLINEANALYSIS_GETDETAIL_RESULT: (state, rst) => {
      state.state_OfflineAnalysis_GetDetailResult = rst;
    },
    SET_OFFLINEANALYSIS_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_OfflineAnalysis_ModifyObjResult = rst;
    },
    SET_OFFLINEANALYSIS_DELETEOBJ_RESULT: (state, rst) => {
      state.state_OfflineAnalysis_DeleteObjResult = rst;
    },
  },
  actions: {
    OfflineAnalysisServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OFFLINEANALYSIS_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OFFLINEANALYSIS_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OfflineAnalysisServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OFFLINEANALYSIS_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OFFLINEANALYSIS_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OfflineAnalysisServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OFFLINEANALYSIS_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OFFLINEANALYSIS_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OfflineAnalysisServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OFFLINEANALYSIS_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OFFLINEANALYSIS_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OfflineAnalysisServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OFFLINEANALYSIS_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OFFLINEANALYSIS_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OfflineAnalysisServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OFFLINEANALYSIS_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OFFLINEANALYSIS_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_OfflineAnalysis_GetAllResult: state => {
      return state.state_OfflineAnalysis_GetAllResult;
    },
    get_OfflineAnalysis_SearchByNameResult: state => {
      return state.state_OfflineAnalysis_SearchByNameResult;
    },
    get_OfflineAnalysis_GetPageResult: state => {
      return state.state_OfflineAnalysis_GetPageResult;
    },
    get_OfflineAnalysis_GetDetailResult: state => {
      return state.state_OfflineAnalysis_GetDetailResult;
    },
    get_OfflineAnalysis_ModifyObjResult: state => {
      return state.state_OfflineAnalysis_ModifyObjResult;
    },
    get_OfflineAnalysis_DeleteObjResult: state => {
      return state.state_OfflineAnalysis_DeleteObjResult;
    },
  }
}